<template>
  <div>
    <DatePicker
      show-time
      :show-now="false"
      placeholder="Select Date"
      format="D MMM, h:mm A"
      @change="onRangeChange"
      :disableDate="disabledDate"
      @open-change="onOpenChange"
      :disabled-date="disabledDate"
    >
    </DatePicker>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from 'vue';
import dayjs from 'dayjs';
import { DatePicker } from 'ant-design-vue';

const props = defineProps({
  dateValue: {
    type: Object,
    default: () => dayjs(),
  },
});

const emit = defineEmits(['onDateChange']);

const date = ref(props.dateValue);
const customPicker = ref(true);
const selectDate = ref('setting.selectDate');

const onRangeChange = (selectedDate) => {
  if (customPicker.value) {
    date.value = selectedDate;
  } else {
    date.value && emit('onDateChange', date.value);
  }
};

const onOpenChange = (open) => {
  if (customPicker.value) {
    date.value && emit('onDateChange', date.value);
  }
};

const disabledDate = (current) => {
  if (customPicker.value) {
    const oneDayAhead = dayjs(date.value).add(1, 'day');
    if (current) {
      return current > dayjs().endOf('day') || current < dayjs().add(-90, 'd');
    }
    return (
      current > dayjs().endOf('day') ||
      current < dayjs().add(-90, 'd') ||
      current < dayjs(date.value) ||
      current > oneDayAhead
    );
  }
  return current > dayjs().endOf('day') || current < dayjs().add(-90, 'd');
};

watch(
  () => props.dateValue,
  (newVal) => {
    date.value = newVal;
  },
);
</script>

<style lang="scss" scoped></style>
